import React, { useState } from 'react';
import ConfirmationModal from './ConfirmationModal';
import Notification from './Notification';
import './SearchBar.css';

const SearchBar = ({ 
  searchTerm, 
  setSearchTerm, 
  hasChanges, 
  saveChanges, 
  undoChanges, 
  updating,
  tableLocked,
  editedData
}) => {

  const [showSaveModal, setShowSaveModal] = useState(false);
  const [showUndoModal, setShowUndoModal] = useState(false);

  // Debug logging

  const handleUpdate = () => {
    setShowSaveModal(true);
  };

  const handleConfirmSave = async () => {
    setShowSaveModal(false);
    const result = await saveChanges();
    if (result && result.success) {
      // Success feedback could be shown here
    }
  };

  const handleCancelSave = () => {
    setShowSaveModal(false);
  };

  const handleUndo = () => {
    setShowUndoModal(true);
  };

  const handleConfirmUndo = () => {
    setShowUndoModal(false);
    undoChanges();
  };

  const handleCancelUndo = () => {
    setShowUndoModal(false);
  };

  return (
    <div className="search-bar-container">
      <div className="search-input-container">
        <input
          type="text"
          id="product-search"
          name="product-search"
          placeholder="Search products..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        <div className="search-icon">🔍</div>
      </div>
      
      {hasChanges && (
        <div className="action-buttons">
          <button 
            onClick={handleUpdate}
            className="update-button"
            disabled={updating || tableLocked}
          >
            {updating ? 'Updating...' : 'Save'}
          </button>
          <button 
            onClick={handleUndo}
            className="undo-button"
            disabled={updating || tableLocked}
          >
            Undo
          </button>
        </div>
      )}
      
      {/* Debug info */}
      <div style={{color: 'red', fontSize: '12px', marginTop: '10px'}}>
        Debug: hasChanges={hasChanges.toString()}, editedKeys={Object.keys(editedData || {}).length}
      </div>
      
      <ConfirmationModal
        isOpen={showSaveModal}
        onConfirm={handleConfirmSave}
        onCancel={handleCancelSave}
        title="Confirm Save"
        message="Are you sure you want to save these changes? This action cannot be undone."
        confirmText="Save"
        cancelText="Cancel"
      />
      
      <ConfirmationModal
        isOpen={showUndoModal}
        onConfirm={handleConfirmUndo}
        onCancel={handleCancelUndo}
        title="Confirm Undo"
        message="Are you sure you want to undo all changes? This will revert to the last saved state."
        confirmText="Undo"
        cancelText="Cancel"
      />
    </div>
  );
};

export default SearchBar;
